import * as tslib_1 from "tslib";
import { environment } from 'src/environments/environment';
var HelperService = /** @class */ (function () {
    function HelperService() {
    }
    HelperService.getQueryString = function (find, select) {
        var _this = this;
        if (find === void 0) { find = {}; }
        if (select === void 0) { select = []; }
        var keywords = Object.keys(find);
        var specialOperator = [
            'sort',
            'limit',
            'offset',
        ];
        var queryString = keywords.reduce(function (acc, keyword, index) {
            var findCondition = find[keyword];
            if (specialOperator.includes(keyword)) {
                acc += keyword + "=" + findCondition;
            }
            else if (findCondition instanceof Array) {
                acc += keyword + "__in=" + findCondition.join(',');
            }
            else if (typeof findCondition === 'object') {
                acc += _this.makeConditionQuery(keyword, findCondition);
            }
            else {
                acc += keyword + "__eq=" + findCondition;
            }
            acc += "&";
            return acc;
        }, '');
        if (select && select.length) {
            queryString += "select=" + select.join(',');
        }
        return queryString;
    };
    HelperService.queryString = function (query) {
        if (query === void 0) { query = {}; }
        var keywords = Object.keys(query);
        var queryString = keywords.reduce(function (acc, keyword) {
            var findCondition = query[keyword];
            // if (specialOperator.includes(keyword)) {
            //   acc += `${keyword}=${findCondition}`;
            // } else if (findCondition instanceof Array) {
            //   acc += `${keyword}__in=${findCondition.join(',')}`;
            // } else if (typeof findCondition === 'object' ) {
            //   acc += this.makeConditionQuery(keyword, findCondition);
            // } else {
            acc += keyword + "=" + findCondition;
            // }
            acc += "&";
            return acc;
        }, '');
        return queryString;
    };
    HelperService.makeConditionQuery = function (parent, condition) {
        var conditionOperators = Object.keys(condition);
        var conditionQueryString = conditionOperators.map(function (cond) {
            return parent + "__" + cond + "=" + condition[cond];
        });
        return conditionQueryString.join('&');
    };
    HelperService.timestampToReadableFormat = function (timeStamp) {
        var date = new Date(timeStamp);
        var timeString = date.toLocaleTimeString().split(':').splice(0, 2).join(':');
        return timeString + " " + HelperService.dateString(date);
    };
    HelperService.isValidDate = function (date) {
        return (date && date.getTime()) ? true : false;
    };
    Object.defineProperty(HelperService, "SHARED_IDENTITY_COOKIE_NAMES", {
        get: function () {
            var names = environment.sharedIdentityCookieNames;
            return Array.isArray(names) && names.length ? names : ['token', 'permission'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HelperService, "AUTH_COOKIE_MAX_AGE_SEC", {
        get: function () {
            var maxAge = Number(environment.authCookieMaxAgeSec);
            return isFinite(maxAge) && maxAge > 0 ? maxAge : 12 * 60 * 60;
        },
        enumerable: true,
        configurable: true
    });
    HelperService.setCookie = function (data) {
        if (data === void 0) { data = {}; }
        Object.keys(data).map(function (key) {
            var value = data[key];
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }
            document.cookie = key + "=" + value + ";path=/";
        });
    };
    /** Serialize permission list for the shared `permission` cookie (comma-joined slugs). */
    HelperService.serializePermissionCookieValue = function (permission) {
        if (!permission && permission !== 0) {
            return '';
        }
        if (typeof permission === 'string') {
            return permission.split(',').map(function (p) { return p.trim(); }).filter(Boolean).join(',');
        }
        if (!Array.isArray(permission)) {
            return '';
        }
        return permission.map(function (item) {
            if (typeof item === 'string') {
                return item.trim();
            }
            return (item && (item.name || item.slug)) || '';
        }).filter(Boolean).join(',');
    };
    HelperService.getAuthCookieWriteOptions = function () {
        var domain = HelperService.getSharedCookieDomain();
        var secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
        return tslib_1.__assign({}, (domain ? { domain: domain } : {}), { sameSite: secure ? 'None' : 'Lax', secure: secure, maxAge: HelperService.AUTH_COOKIE_MAX_AGE_SEC });
    };
    HelperService.writeAuthCookie = function (name, value, options) {
        if (options === void 0) { options = {}; }
        if (!name || !value) {
            return;
        }
        var attrs = [
            'path=/',
            "max-age=" + (options.maxAge != null ? options.maxAge : HelperService.AUTH_COOKIE_MAX_AGE_SEC),
        ];
        if (options.domain) {
            attrs.push("domain=" + options.domain);
        }
        if (options.sameSite) {
            attrs.push("SameSite=" + options.sameSite);
        }
        if (options.secure) {
            attrs.push('Secure');
        }
        // Encode so JWT / permission payloads never break cookie parsing.
        document.cookie = name + "=" + encodeURIComponent(value) + ";" + attrs.join(';');
    };
    /**
     * Writes shared-parent-domain auth cookies (host-only on localhost).
     * Same contract CSCC primes for payroll: token / permission.
     */
    HelperService.setAuthCookies = function (session) {
        if (session === void 0) { session = {}; }
        var options = HelperService.getAuthCookieWriteOptions();
        var token = HelperService.normalizeAuthToken(session.token || '');
        if (token) {
            HelperService.writeAuthCookie('token', token, options);
        }
        var permission = HelperService.serializePermissionCookieValue(session.permission);
        if (permission) {
            HelperService.writeAuthCookie('permission', permission, options);
        }
    };
    HelperService.regexString = function (string) {
        return string + "$/i";
    };
    HelperService.roundNumber = function (num) {
        // const roundTwoDecimal = (num) => {
        return Math.round(num * 100) / 100;
        //  };
    };
    HelperService.accessCookie = function (cookieName) {
        var name = cookieName + '=';
        var allCookieArray = document.cookie ? document.cookie.split(';') : [];
        var emptyMatch = '';
        for (var i = 0; i < allCookieArray.length; i++) {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name) !== 0) {
                continue;
            }
            var value = temp.substring(name.length, temp.length);
            if (value.indexOf('%') !== -1) {
                try {
                    value = decodeURIComponent(value);
                }
                catch (e) {
                    // keep raw value when decode fails
                }
            }
            // Prefer non-empty values so a stale host-only `token=` does not
            // shadow the shared-domain SSO cookie primed by CSCC.
            if (value) {
                return value;
            }
            emptyMatch = value;
        }
        return emptyMatch;
    };
    /** Matches CSCC embedAuthBootstrap domain scoping for shared SSO cookies. */
    HelperService.getSharedCookieDomainForHostname = function (hostname) {
        if (!hostname || hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
            return '';
        }
        var labels = hostname.split('.');
        if (labels.length < 2) {
            return '';
        }
        var envLabel = labels.length >= 3 ? labels[labels.length - 3] : '';
        var shouldScopeToEnv = ['staging', 'develop'].includes(envLabel);
        return "." + labels.slice(shouldScopeToEnv ? -3 : -2).join('.');
    };
    HelperService.getSharedCookieDomain = function () {
        if (typeof window === 'undefined') {
            return '';
        }
        return HelperService.getSharedCookieDomainForHostname(window.location.hostname);
    };
    HelperService.normalizeAuthToken = function (raw) {
        if (!raw) {
            return '';
        }
        var token = String(raw).trim();
        // Decode first so URI-encoded "Bearer%20…" cookies still lose the prefix.
        if (token.indexOf('%') !== -1) {
            try {
                token = decodeURIComponent(token);
            }
            catch (e) {
                // keep raw token when decode fails
            }
        }
        return token.replace(/^Bearer\s+/i, '').trim();
    };
    HelperService.expireCookie = function (name, options) {
        if (options === void 0) { options = {}; }
        var attrs = [
            'path=/',
            'max-age=0',
            'expires=Thu, 01 Jan 1970 00:00:00 GMT',
        ];
        if (options.domain) {
            attrs.push("domain=" + options.domain);
        }
        if (options.sameSite) {
            attrs.push("SameSite=" + options.sameSite);
        }
        if (options.secure) {
            attrs.push('Secure');
        }
        document.cookie = name + "=;" + attrs.join(';');
    };
    /**
     * Clears host-only cookies and CSCC shared-domain identity cookies
     * (token / permission) so SSO sessions end on logout.
     */
    HelperService.clearAuthCookies = function () {
        var hostCookieNames = document.cookie
            ? document.cookie.split(';').map(function (part) {
                var eqPos = part.indexOf('=');
                return (eqPos > -1 ? part.substring(0, eqPos) : part).trim();
            }).filter(Boolean)
            : [];
        hostCookieNames.forEach(function (name) {
            HelperService.expireCookie(name);
        });
        var domain = HelperService.getSharedCookieDomain();
        if (!domain) {
            return;
        }
        var secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
        var sharedOptions = {
            domain: domain,
            sameSite: secure ? 'None' : 'Lax',
            secure: secure,
        };
        HelperService.SHARED_IDENTITY_COOKIE_NAMES.forEach(function (name) {
            HelperService.expireCookie(name, sharedOptions);
        });
    };
    HelperService.dateString = function (date) {
        if (date && Date.parse(date)) {
            return new Date(date).toDateString();
        }
        return 'N/A';
    };
    HelperService.getCurrentUrl = function () {
        return window.location.href;
    };
    HelperService.getCurrentPath = function () {
        return window.location.pathname;
    };
    HelperService.reload = function () {
        return window.location.reload();
    };
    HelperService.routeParams = function () {
        return decodeURIComponent(window.location.search.substring(1)).split('&')
            .reduce(function (acc, keyValue) {
            var data = keyValue.split('=');
            acc[data[0]] = data[1];
            return acc;
        }, {});
    };
    HelperService.removeParam = function (params) {
        if (params === void 0) { params = []; }
        var baseUrl = window.location.origin;
        var pathname = window.location.pathname;
        var routeParams = this.routeParams();
        var filteredParams = Object.keys(routeParams).reduce(function (acc, param) {
            if (!params.includes(param)) {
                acc[param] = routeParams[param];
            }
            return acc;
        }, {});
        return "" + baseUrl + pathname + "?" + HelperService.queryString(filteredParams);
    };
    HelperService.minutesToReadableHourMinuteFormat = function (minutes) {
        var date = new Date('1-1-2019');
        date.setMinutes(minutes);
        var readableString = '';
        if (date.getHours()) {
            readableString = date.getHours() + " hours";
        }
        if (date.getMinutes()) {
            readableString += " " + date.getMinutes() + " min";
        }
        return readableString.trim();
    };
    HelperService.encode = function (data) {
        return btoa(btoa(data));
    };
    HelperService.decode = function (data) {
        try {
            return atob(atob(data));
        }
        catch (err) {
            console.log(err);
            return data;
        }
    };
    HelperService.redirectToOldDashboard = function (relativeRoute, queryParams) {
        if (queryParams === void 0) { queryParams = {}; }
        var basePath = environment.rapido_dashboard;
        var token = HelperService.accessCookie('token');
        var queryString = HelperService.queryString(Object.assign({ token: token }, queryParams));
        var path = basePath + "/" + relativeRoute + "?" + queryString;
        // const path = `${basePath}/${relativeRoute}?token=${token}`;
        // window.location.replace(path);
        window.open(path);
    };
    HelperService.redirectToNewPage = function (url) {
        window.open(url);
    };
    HelperService.redirect = function (url) {
        var referrer = document.URL;
        window.location.replace(url + "?referrer=" + referrer);
    };
    HelperService.openInMap = function (lat, lng) {
        if (lat && lng) {
            var googleUrl = "https://maps.google.com/?q=" + lat + "," + lng;
            this.redirectToNewPage(googleUrl);
        }
    };
    HelperService.deocodeJwtPayload = function (data) {
        var base64Url = data.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var response = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return response;
    };
    HelperService.debounce = function (func, delay) {
        if (delay === void 0) { delay = 3000; }
        var debounceTimer;
        return function () {
            var context = this;
            var args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () { return func.apply(context, args); }, delay);
        };
    };
    return HelperService;
}());
export { HelperService };
